import Cookies from 'js-cookie'

let loginTypeName: any = ''
let from: any = ''
const refresh = () => {
    loginTypeName = localStorage.getItem('loginTypeName')
    if (loginTypeName == 'chatlibrary') {
        from = 'CI'
    } else {
        from = 'none'
    }
}

export const setCookie = (name: string, value: string, prod: boolean) => {
    // eslint-disable-next-line
    refresh()
    const fromname = from + name
    if (prod) {
        if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
            const newname = 'test_' + fromname
            Cookies.set(newname, value, { domain: '.inkai.info' })
        } else {
            Cookies.set(fromname, value, { domain: '.inkai.info' })
        }
    } else {
        Cookies.set(fromname, value)
    }
}

export const getCookie = (name: string) => {
    refresh()
    const fromname = from + name
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        const newname = 'test_' + fromname
        return Cookies.get(newname)
    } else {
        return Cookies.get(fromname)
    }
}

export const removeCookie = (name: string) => {
    refresh()
    const fromname = from + name
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        const newname = 'test_' + fromname
        Cookies.remove(newname)
    } else {
        Cookies.remove(fromname)
    }
}

export const clearAllCookie = () => {
    refresh()
    if (window.location.origin.indexOf('test') > -1 || window.location.origin.indexOf('192') > -1) {
        Cookies.remove('test_' + from + 'UserInfo', { domain: '.inkai.info' })
        Cookies.remove('test_' + from + 'Token', { domain: '.inkai.info' })
    } else {
        Cookies.remove(from + 'UserInfo', { domain: '.inkai.info' })
        Cookies.remove(from + 'Token', { domain: '.inkai.info' })
    }
}
